import { useEffect } from 'react';

import { useLocation } from 'react-router';

const ScrollToTop = () => {
    const location = useLocation();

    useEffect(() => {
        // Scroll to top on location change unless preventScroll is set
        if (!location.state || !location.state.preventScroll) {
            window.scrollTo(0, 0);
        }
    }, [location.pathname, location.search, location.state]);

    return null;
};

export default ScrollToTop;
